/* ABC: общее окно-шторка снизу (на ПК — по центру), как «SELECT A SIZE»
   у Balenciaga. Используют: «сообщить о поступлении» (NOTIFY ME) и выбор
   размера при переносе из избранного в корзину.
   window.abcSheet.open({ title, body: HTMLElement|string, onClose })
   window.abcSheet.close()
   Это <dialog> с showModal(): поверх всего, в том числе мини-корзины. */
(function () {
  var dlg = null;
  var onCloseCb = null;
  var CLOSE_MS = 290;   // уход окна 0.26с (abc-custom.css «п.7 (35)») + запас

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'abc-sheet';
    dlg.innerHTML =
      '<div class="abc-sheet__panel" role="document">' +
        '<div class="abc-sheet__head"><span class="abc-sheet__title"></span>' +
        '<button type="button" class="abc-sheet__close" aria-label="Close"></button></div>' +
        '<div class="abc-sheet__body"></div>' +
      '</div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.abc-sheet__close').addEventListener('click', close);
    /* нажатие по затемнению вокруг панели закрывает */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    /* 04.10: причина «дёрганого вылета». showModal() ставит фокус на кнопку в панели, пока панель
       ещё за нижним краем, и браузер прокручивает само окно (overflow:hidden всё равно прокручивается
       из кода). Chrome: панель вставала на место почти сразу; Safari: улетала вверх за экран и в конце
       прыгала. Окно не прокручивается (overflow:clip в abc-custom.css) + на всякий случай сбрасываем */
    dlg.addEventListener('scroll', function () { if (dlg.scrollTop || dlg.scrollLeft) { dlg.scrollTop = 0; dlg.scrollLeft = 0; } });
  }

  function open(opts) {
    if (!dlg) build();
    var wasOpen = dlg.open && !dlg.classList.contains('is-closing');
    var panel0 = dlg.querySelector('.abc-sheet__panel');
    var h0 = wasOpen ? panel0.offsetHeight : 0;
    dlg.querySelector('.abc-sheet__title').textContent = opts.title || '';
    var body = dlg.querySelector('.abc-sheet__body');
    body.innerHTML = '';
    if (typeof opts.body === 'string') body.innerHTML = opts.body; else if (opts.body) body.appendChild(opts.body);
    onCloseCb = opts.onClose || null;
    dlg.classList.remove('is-closing');
    /* открыто из мини-корзины на ПК — выезжает снизу внутри шторки, по её ширине */
    var panel = dlg.querySelector('.abc-sheet__panel');
    var anchor = opts.anchor && document.querySelector(opts.anchor);
    var r = anchor && matchMedia('(min-width: 750px)').matches ? anchor.getBoundingClientRect() : null;
    dlg.classList.toggle('abc-sheet--anchored', !!(r && r.width));
    /* 04.10: внутри левой чёрной линии шторки (её рамка 1px), а не поверх — окно было шире корзины */
    var bl = r && r.width ? parseFloat(getComputedStyle(anchor).borderLeftWidth) || 0 : 0;
    panel.style.left = r && r.width ? (r.left + bl) + 'px' : '';
    panel.style.width = r && r.width ? (r.width - bl) + 'px' : '';
    if (!dlg.open) {
      dlg.showModal();
    } else if (body.animate) {
      /* окно уже открыто (например, из выбора размера в NOTIFY ME) —
         новое содержимое проявляется плавно, а не подменяется рывком.
         25.09: и высота панели меняется плавно — раньше панель скачком
         становилась выше/ниже (на телефоне прыгал её верх) */
      var h1 = panel.offsetHeight;
      if (wasOpen && h0 && Math.abs(h1 - h0) > 1) {
        panel.style.overflow = 'hidden';
        var a = panel.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }],
          { duration: 320, easing: 'cubic-bezier(.32,.72,0,1)' });
        a.onfinish = a.oncancel = function () { panel.style.overflow = ''; };
      }
      body.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }],
        { duration: 260, delay: 60, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'backwards' });
    }
    return body;
  }

  /* after — что сделать, когда окно уже уехало. 25.09 (владелец прислал видео):
     в корзине после выбора размера/цвета тема сразу поднимает мини-корзину
     поверх всех окон, и уезжающее окно вместе с затемнением пропадало под ней
     за один кадр. Теперь смену товара запускаем после ухода окна. */
  function close(after) {
    if (!dlg || !dlg.open) { if (typeof after === 'function') after(); return; }
    if (dlg.classList.contains('is-closing')) { if (typeof after === 'function') setTimeout(after, CLOSE_MS); return; }
    dlg.classList.add('is-closing');
    setTimeout(function () {
      dlg.classList.remove('is-closing');
      if (dlg.open) dlg.close();
      if (onCloseCb) { var c = onCloseCb; onCloseCb = null; c(); }
      if (typeof after === 'function') after();
    }, CLOSE_MS);
  }

  /* NOTIFY ME — сохраняем покупателя в Shopify: Клиенты → тег
     «back-in-stock» + товар и размер. Это и есть база «кто что ждёт». */
  function notifyForm(product, size) {
    var f = document.createElement('form');
    f.className = 'abc-notify';
    f.innerHTML =
      '<p class="abc-notify__text">' +
        '<span class="abc-notify__product"></span><br>' +
        'Size <b class="abc-notify__size"></b> is sold out. Leave your email and we will let you know when it is back.' +
      '</p>' +
      '<input class="abc-notify__email" type="email" name="email" required placeholder="EMAIL" autocomplete="email">' +
      '<button class="abc-notify__submit" type="submit">NOTIFY ME</button>' +
      '<p class="abc-notify__msg" role="status"></p>';
    f.querySelector('.abc-notify__product').textContent = product.title || '';
    f.querySelector('.abc-notify__size').textContent = size || '';
    /* Отправка — обычной формой, не «в фоне»: фоновый запрос Shopify
       отклоняет (403, защита от ботов). Обычную форму Shopify принимает,
       при необходимости сам показывает проверку и возвращает на эту же
       страницу с ?customer_posted=true — тогда показываем «спасибо». */
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = f.querySelector('.abc-notify__email').value.trim();
      if (!email) return;
      try { sessionStorage.setItem('abc-notify', JSON.stringify({ title: product.title || '', size: size || '' })); } catch (err) {}
      var real = document.createElement('form');
      real.method = 'post';
      real.action = '/contact#abc-notify';
      real.style.display = 'none';
      var fields = {
        form_type: 'customer',
        utf8: '✓',
        'contact[email]': email,
        'contact[tags]': ['back-in-stock', 'bis:' + (product.handle || ''), 'bis-size:' + (size || '')].join(',')
      };
      Object.keys(fields).forEach(function (k) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = k; i.value = fields[k];
        real.appendChild(i);
      });
      document.body.appendChild(real);
      f.querySelector('.abc-notify__submit').disabled = true;
      real.submit();
    });
    return f;
  }

  /* вернулись после отправки NOTIFY ME */
  function afterNotify() {
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem('abc-notify') || 'null'); } catch (e) {}
    if (!data || !/customer_posted=true/.test(location.search + location.hash)) return;
    try { sessionStorage.removeItem('abc-notify'); } catch (e) {}
    open({ title: 'Notify me', body: '<p class="abc-notify__text"><span class="abc-notify__product"></span><br>Thank you! We will email you when size <b></b> is back.</p>' });
    var body = dlg.querySelector('.abc-sheet__body');
    body.querySelector('.abc-notify__product').textContent = data.title;
    body.querySelector('b').textContent = data.size;
    history.replaceState(null, '', location.pathname);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterNotify); else afterNotify();

  window.abcSheet = { open: open, close: close, notifyForm: notifyForm };
})();
